import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { resolvePrivatePhoto } from '@/lib/privatePhotos';

export function usePrivatePhoto(value?: string | null) {
  const [url,setUrl]=useState<string>();
  useEffect(()=>{
    let live=true; let generation=0;
    const refresh=async()=>{
      const current=++generation;setUrl(undefined);
      if(!value)return;
      try {const next=await resolvePrivatePhoto(value);if(live&&current===generation)setUrl(next);}
      catch {if(live&&current===generation)setUrl(undefined);}
    };
    void refresh();
    const timer=setInterval(()=>void refresh(),240000);
    // Defer network calls outside Supabase's auth callback lock.
    const {data}=supabase.auth.onAuthStateChange(()=>{generation++;setUrl(undefined);setTimeout(()=>{if(live)void refresh();},0);});
    return()=>{live=false;generation++;clearInterval(timer);data.subscription.unsubscribe();};
  },[value]);
  return url;
}
